
function Registrese() {
    return(<>
<div className='Informacion'>
    <h1>Afiliese con Chamuscón para acceder a estas opciones</h1>
    <div className='Nosotros'>
        {/** <div className='logoeninfo'><Logoicono/></div> */}
        <h2>
            Nosotros
        </h2>
    </div>{/** -20 margin top */}
    <p style={{textAlign:'justify', margin:'0 25px 0 25px'}}>Habiendo disfrutado tanto tiempo del fútbol, surge la idea de facilitar la organización de "chamuscas" poniendo a la 
        disposición de quienes gustan de este deporte, la oportunidad de organizarlas de masnera mas sencilla, buscando por cercanía y verificando la disponibilidad. Sabiendo que <i>no sirve 
        la banda</i>, se facilita tener la opcion de ver rapidamente los horarios dispinibles y la rapidez del pago en linea para poder disfrutar con amigos y familia de estos encuentros 
        deportivos saludables. (Las chelas despues del partido no nos competen, cuidense &#128536;)
    </p>
</div>
  
    </>)
}
export default Registrese;